import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RelatorioCadastro } from '@/features/relatorio/page/cadastro/RelatorioCadastro';

const searchSchema = z.object({
    tab: z.enum(['clientes', 'fornecedores', 'transportadores', 'produtos']).default('clientes'),
});

export const Route = createFileRoute('/a/relatorio/cadastro/')({
    component: RelatorioCadastro,
    validateSearch: searchSchema,
});
